import { useSharedTranslation } from 'Translation/useSharedTranslation';
import { GuidLineComponent } from './EmrysNutritionStyle';
const GuidLineNutrition = () => {
    const { t } = useSharedTranslation();
    return (
        <GuidLineComponent>
            <svg
                style={{ width: '100%', height: 'auto' }}
                viewBox='0 0 1440 813'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect
                    style={{ width: '100%' }}
                    height='813'
                    fill='#CCF5B9'
                    fillOpacity='0.25'
                />
                <rect
                    x='1199.24'
                    y='225.204'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(90 1199.24 225.204)'
                    fill='url(#pattern0_2649_110996)'
                />
                <path
                    d='M74.5359 554.55C152.009 483.309 174.415 419.829 278.141 397.175C378.412 375.276 456.374 492.658 556.746 471.48C662.697 449.125 664.654 317.86 770.606 295.505C870.978 274.327 940.651 389.728 1033.96 374.045C1127.27 358.361 1137.44 249.74 1172.5 205.5'
                    stroke='#46A418'
                    strokeWidth='3'
                    strokeLinecap='round'
                    strokeDasharray='10 10'
                />
                <rect
                    x='532.579'
                    y='441.921'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(-53.7139 532.579 441.921)'
                    fill='url(#pattern1_2649_110996)'
                />
                <rect
                    x='313.562'
                    y='416.554'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(90 313.562 416.554)'
                    fill='url(#pattern2_2649_110996)'
                />
                <rect
                    x='50.3352'
                    y='521.981'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(-51.6954 50.3352 521.981)'
                    fill='url(#pattern3_2649_110996)'
                />
                <rect
                    x='788.623'
                    y='309.06'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(78.2857 788.623 309.06)'
                    fill='url(#pattern4_2649_110996)'
                />
                <rect
                    x='1010.83'
                    y='341.929'
                    width='32.0334'
                    height='30.4411'
                    transform='rotate(-46.9244 1010.83 341.929)'
                    fill='url(#pattern5_2649_110996)'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 57 552)'
                    fill='#2B6E0A'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 279.636 386.11)'
                    fill='#2B6E0A'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 538.903 463.604)'
                    fill='#2B6E0A'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 752.145 288.821)'
                    fill='#2B6E0A'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 1014.71 366.227)'
                    fill='#2B6E0A'
                />
                <ellipse
                    cx='8.57765'
                    cy='8.62174'
                    rx='8.57765'
                    ry='8.62174'
                    transform='matrix(1 0.000221689 0.000224181 1 1168.58 193.984)'
                    fill='#2B6E0A'
                />
                <defs>
                    <pattern
                        id='pattern0_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern1_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern2_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern3_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern4_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <pattern
                        id='pattern5_2649_110996'
                        patternContentUnits='objectBoundingBox'
                        width='1'
                        height='1'
                    >
                        <use
                            xlinkHref='#image0_2649_110996'
                            transform='matrix(0.00748261 0 0 0.00787402 0.0173719 0)'
                        />
                    </pattern>
                    <image
                        id='image0_2649_110996'
                        width='129'
                        height='127'
                        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAB/CAYAAADIOKE5AAAACXBIWXMAABcRAAAXEQHKJvM/AAANGElEQVR4nO1dP2xjSR2eDRRILnKiQHIBmxIkS5uGEm2OxuWGOsVlJSqE5BSHRIPOaRDd2S3NOYUlOrICnZTqbAmuuIK1haUVIPbsuws+LcsmTtaJndgxmug3uYn9Zt78+c28efb7pNVmN7bzMvPN9/s7Mw9msxnRQbGebxFCto52+qdab8wQHAql3C4hpLFm8GB08ivZlC4Fyp3qsGtCAor3ivV8edVHMM0AFbiFKQkoPijW89srPZIpRaGUe4eqACGkSyxJQFEr1vObqzqYKcYeIeQhIYT6d9YkWAcivLPKI5omFEo5umg/gEe+de5tSUDxiBJhJUYw5QAzcMj9FihKwPAkcxRTgQqYAQY0JWCgjuLWso5e2lEo5agf8N7cr4GqBAyHmX8QHgqlHI3iPpx/sE51iK4EBBzFRjqHajkBjmCUz9ZkX5iQYCPm+4+K9XyWUQwAQIAGLE4hTEjwUOE1pSyRlCwUCHCn2NjmgAfNH8SpRgYHUFUABi0SaE7q+lxMmsEDwAlUIYCxEuiu7EdZ/sAfoCj0R0UFuGsFcE0CkuUP/KBQytEI4CPVH9apDlvsax8kIFl9wR1oKrhQyjUiEkEyDPjv6ZLAtGL4MKsv4KNQym1BOfix5oe3+H/4IgGB+sKuwusyKKBQylFf6xPVCGAOXf6fyiQAOVfJEchQycJGO9Dwr1DKtbhysAnMSECbSxF+h/XMLJgDVv9zKN/bIFESUDwu1vN7SJ+1EqC2v1DKdS1XPw9jEmCmgctZW1o8CqXcRqGUOwTbb2uKedwjwbdV3gF2HPMhmFnIiBABOvnQCKoT9imDtpnzr1VVAhde/aPMLNwHOH10cXzuigCEkPb8fyRJAgJmYeWjBbD5DXD6XE0+w8LOsVhzACVhTFPAg5mFlUwrQ7KnbJDssUFr/r0qSuBaslcuWuBW/ieeCUCilEBKAlABHw9ZXoXaQsKTz7CgBEJzAJPiq01sHX7WUqaVE5J9ERaUQLg1vVjP1zw4KfN492invzSNqoFN/i061eGD+f+LVALw2H0TgIAapD53EOLkyyDyCZLqBkp17iAQmy9DM+p7C+YAfIGuYYkSA7ThYSNNJ6FAhq+WgpXf7FSHC+F4lDnYTpAABH522UNoag3X6V0HiPS3osxBCINfCjmTCC1dZcfpXReIVNd7JIDKnm2tGgtB7mKCjl7Msq5PLOQISIQShBSnPwmpSxnKug3o6E3SXNogXgmQewYoepbvD2LPAmzoaKUl5BOBbzPncUcCMAXYhaKuJREeJ6kGXMinuqEjZAjngY8OXJiCDfBIbZynsu8qIxzrQkO+Jz5/rmN0RR/PmwMXA/0Q4bwCr2rA9fIvEwFILAkgQeQqKoi0Q5rwErZa9vKHjlglcHaWwNFOvzW/7ckAT1zmDSDur6U07FNFLAmcFW1AyoNVA7D/tn5LGhBLAtc2F6M8vIvdeMIRIJQEmUsIFyIjgetBwCDBOqbZWjEC3J1UFoU1T543hjkgyGHs4aoQIKrNnMeaxZkDyoCysG32kEC4aP284ASmOvunCWlZ3gsJAELHRBNWJkFwsueyQ6rEax7auZi5weodNDZfkAhaONkzUGAoJ0OsEvhq9cZSAqNMHjSApOU0tcg2MAtIF6APJWDAIgExdGZrKckEDmDSXO36WsCar4FBbiXXIgGkg9PiCO5hF/M61WGsEviEbfqYQVm95m76CB3P4PkwVSB2zJXOJ0AEVmOGjglLy/E4PVAArJwKQ+zn+VYCrDZypZUC4WAaEkIDCH1d7ACPHXPfJEBjeZxzyLWDpwF74Di7aK4NTgl8opySaOCgUx3WgAgunjcIJWgIvraF0C+ApFAasoJ0R9AuFLNcNc4stRLIklxpMANtLgVecahasfmZpTMHsDkk9JwAdQS3aHkXfBdnqjV/UlkU1pBz1FIgJ4xEha/QVeCOAPBvlyGstITMsIaZzvWMBRKACnhLtxqAEaBFvtnU4lK1lObWBwl8kix0FdjlCODjOCAl5XVOgqOdvhcSpEAFnnaqQ76KWfbwvEp5mbUluswyZBV4CrmAW0A9o+T6h8YVjhjWHOSqeUQVL5ScFR1AXiBUFbhHAICPesYzhdfcYg2x/y8KUQTDqh/wLA9VBRYIAGVtH/UMZYVneYLUmgSIs0PLC1AFfDeCAD7L2spdVIwErtqufDiFoakACwOjFpavsnZbJUnEcEuCo53+IWLDB4+oB8Hqbu5CmBXSncz38gA8PJoBoks2Pm3sQg2iSIDlwHUDOGmNB3V4NwUE2PLc3WRMgrIDNXBpDroBnbHUBgVY+H25Ay984Zlsy1kU7kgASR3sDJYzEhx/dkYCcQhpP8CmZOBrnsNXbcLdqyIe7fTLmOGiw2xhOxBfYJ/2A4i+Ce1tPk886c1lJZUQVUrGktiFDRSIN6C1EibBAHIAwsgEwkHfu52MIqUFEkC5F2MHTJQKoOx2upnM/pGgKeiB/RfKLvgBvnc7DUx/pqipBEMNnKWj3/avkooImqIIYA6HCaSxK7oOIUMkCcCWH1g+VNRAoZyFcN4f/xDjczRRpSeExw10oZSrJKBSAxunXtZeZpWJc3WDyWxGPvbsbNEB/lmnOoxtBIVytvPqYASMVYDISGCpBqJKobUSjE6uXWQ2RWDxf6ytBUfwI4/PxtCzDe3jGk1N1UBkM60dw7Ovxr52UR+IUsDzAAIkVYQr26gAiSOBhRqIBsQqdz67mf1zMrr5kc1nKIDJ/67K4HKRQBLOalMWpahCpeXcRA0WSICRIxi+cm4KWP5fKdTiTkBLqqEFZcNKLAlADXTyBm1BptCaBOfH4x/bfoYE+5D+VcpyBnAE3r6KqVKB6uYTHckRmQIrEozPJi9uptF3OFqiBw0guopXSZAA1s4gDyUSHO30axoVRhFhrCKD8/9c/cDm/QJQf2dTtSGTAY7AS3Kv47atM8hD55CKQ4VfvAcHWkfBeNVMxzdvxmeT75q+PwID2AOgnWYNgABoZoBBZy+iyoBFvgYu3jbG2fEYkwC0C3cjpQRoGpitWOgogYpkopuC6fVsdPH6+jum7+dgvPpJGAQYuKqcKisBtKbLooS2xBQYk+Dk35cYBDgwXf0kDAKQuU2sqNA9uKohKY5EeqtwFrGRP3B1Pp2MzyY2h2v1YPUbZfMCOgn9KbYfwEP3fALRg8hq2cYS9ublpQ0B9k08f4aACFDFyArKoDvIokRKRXLBtVFvwvnxmEYFJm+lJmvPZuVALaAWAAEOVKqXtli4NT0OxXp+/g3CW87BFHyu+4zXFzfTV52339J82wCKKVZJFK4YlHQr+4GsfxETGMfVyFTAyBScvLzUJQBz/GwJQAf9eQAEaPoiAEE40TQufaktZYMvRuT6Yqr68jZIv3UZF3YIhXD8bdN3E60tCfZEKgCHTWpV10YnE/L26yuVlw5g8q0dpsBuQ/VmAnjYmINnsIdRBC0VoKv/5OWlykurIP0YBGD2f2UJQHSVgOsJGMi8fnAIlQd2Np3N/vevywcxVcImxPwoG1rA/rs8P1AH+y7SwarQNQcs87ctcQaJTiMKJcB/X1w8kISDVgmfeXAHRoVy4mnUSSZeoUsC6rA8lXUSgwooDTAjgMARRLP7DAHF/0S2jd03lH0Cdt0t9BbIoKQCEgIMINuHYvcZYF/g80AI0ITfL3ECEF0lONrpS5098BliVUBCgANY/WiFEjjOJqR7EBO1/1HQzhjKUKznZQWmWwgIcADZPtRdzLD6QznyHtW3wQTa9TfQOCIlAJ341y8u+CigCZOPOjABrv4qxv4AV0BRArjNvCtbcRevr8mgNyJAACeTT77J/Lm6QEIXwa5+HlhKIL1zkKaCIRPocvK3EjgVRIbgbL8I1iQAMxCZGKLVQFoMur6Yupz8DYj7Q8j6Eds2tiRgZQ4gJ9CKUgG68gdfjFxOPrsyJhTpJ9hZTV8wVgLwAxb24E0ub65Oupd/vzqfvu/KFgaW8iVYvQxJwcYc3NuBM7shV2+/Hn959tX4544n38cR8TrYtz0fIGkYkaBYz9/rvh2dTr48Px7/4m+/Pfuzi98nwMlnPZXouY0koE2CYj2/ywhw9XbaHr66+t1nvzn9g4tnD3TyK2lf+fPQLSVTJ+zD64vpX0eDya8/ff/NX1w8VICTTx2+WtLVPldQJsFPf/+9P81m5Pvj88lPXEx+gN5+DyS/sgySL4MyCUaDyS8//dUb9MsxIMmzG0h9n018LZQKnw+gFpBUwR1RH8Kt5m3INDZWaeJ5oBWQVAD3AG4nvOrZam/AxC+Ng2cK5ySAbp5dmPwkHL0mZDWzSRfACQkSnPg2TPjtn9Crd6EAhQRg47dg0n3cRtKGW9UaUMJurao9x4AxCcCrZ39cNG+wsxAa3N+n2WTjQ4kEUK7dhD+2k97m7kZswdenbNt7JuH+sRAiwoRvwxG0W9zRc6IVeBrxvdbcJZitzCELFISQ/wOLx1PmICs1ygAAAABJRU5ErkJggg=='
                    />
                </defs>
                <text
                    x='60'
                    y='100'
                    fill='#575756'
                    className='GuidLineTitle'
                >
                    {t('base.nutrition.guidLineTitle')}
                    <tspan fill='#2B6E0A'>*</tspan>
                </text>
                <text
                    x='60'
                    y='625'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    1.
                </text>

                <foreignObject
                    x='95'
                    y='602'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '18em' }}
                    >
                        {t('base.nutrition.guidLineStep1')}
                    </div>
                </foreignObject>
                <text
                    x='279'
                    y='340'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    2.
                </text>
                <foreignObject
                    x='325'
                    y='317'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '18em' }}
                    >
                        {t('base.nutrition.guidLineStep2')}
                    </div>
                </foreignObject>
                <text
                    x='528'
                    y='540'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    3.
                </text>
                <foreignObject
                    x='575'
                    y='517'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '15em' }}
                    >
                        {t('base.nutrition.guidLineStep3')}
                    </div>
                </foreignObject>
                <text
                    x='740'
                    y='230'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    4.
                </text>
                <foreignObject
                    x='790'
                    y='207'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '15em' }}
                    >
                        {t('base.nutrition.guidLineStep4')}
                    </div>
                </foreignObject>
                <text
                    x='990'
                    y='450'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    5.
                </text>
                <foreignObject
                    x='1040'
                    y='428'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '20em' }}
                    >
                        {t('base.nutrition.guidLineStep5')}{' '}
                        <a
                            className='GuidLineText'
                            style={{ textDecoration: 'underline', color: 'unset' }}
                            href={'https://emrysnutrition.com/fr/'}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            https://emrysnutrition.com/fr/
                        </a>
                    </div>
                </foreignObject>
                <text
                    x='1150'
                    y='160'
                    fill='#575756'
                    className='GuidLineNumber'
                >
                    6.
                </text>
                <foreignObject
                    x='1200'
                    y='138'
                    width='500'
                    height='200'
                    xmlns='http://www.w3.org/1999/xhtml'
                >
                    <div
                        className='GuidLineText'
                        style={{ width: '12em' }}
                    >
                        {t('base.nutrition.guidLineStep6')}
                    </div>
                </foreignObject>
            </svg>
        </GuidLineComponent>
    );
};

export default GuidLineNutrition;
